var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    stroke: "#99A3AC",
    d: "M9 16.5q-3.325 0-5.662-2.338Q1 11.826 1 8.5t2.338-5.662Q5.675.5 9 .5q2.125 0 3.725.863A8.8 8.8 0 0 1 15.5 3.725V.5H17v6.35h-6.35v-1.5h4.2a7.66 7.66 0 0 0-2.425-2.425Q10.95 2 9 2 6.275 2 4.388 3.888T2.5 8.5t1.888 4.613T9 15q2.075 0 3.8-1.187t2.4-3.138h1.55q-.725 2.625-2.875 4.225T9 16.5Z"
  })));
};
export default SvgReload;